module.exports = __webpack_public_path__ + "static/media/sello.97cd2b43.svg";